import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { getCommodityRates } from "@/lib/api/commodity-rates"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { commodityRate } from "@/components/table/columns/commodity-rate-column"

import AddCommodityRatePage from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/commodity-rates/",
)({
  component: CommodityRatesPage,
})

function CommodityRatesPage() {
  const {
    data: commodityRatesDetails,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["commodityRates"],
    queryFn: () => getCommodityRates(),
  })

  return (
    <main className="space-y-4 p-4">
      <Header>Commodity Rates</Header>
      <div className="print:p-2">
        <DataTable
          columns={commodityRate}
          data={commodityRatesDetails?.results ?? []}
          search={{
            field: "rate_type",
            label: "rate type",
          }}
          //tableTitle="Connection Status"
          isLoading={isLoading}
          isError={isError}
        >
          <div className="flex w-full justify-end">
            <AddCommodityRatePage />
          </div>
        </DataTable>
      </div>
    </main>
  )
}
